import React from "react";
import { Alert, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faCircleCheck,
  faCommentDots,
  faLayerGroup,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

export default function AlertCriticalSection({
  darkMode = false,
  rows = [],
  expanded = false,
  onToggleExpanded,
  onCopyMessage,
  PostventaBadge,
  toneForPriority,
  toneForGestionState,
  toneForSegment,
  toneForPattern,
}) {
  const visibleRows = expanded ? rows : rows.slice(0, 3);

  return (
    <section className={`crm-postventa-panel crm-alert-surface crm-alert-critical-panel ${darkMode ? "is-dark" : ""}`}>
      <div className="crm-alert-section-header">
        <div>
          <h3>Alertas criticas</h3>
          <span className="crm-postventa-card-label">Revision prioritaria para el equipo de Postventa</span>
        </div>
        <div className="crm-alert-total-pill">{rows.length} alertas</div>
      </div>

      <div className="crm-alert-critical-scroll">
        <div className="crm-alert-critical-list">
          {visibleRows.length ? visibleRows.map((item, index) => (
            <article className="crm-alert-critical-card" key={`${item.cuit}-${item.tipoAlerta}-${index}`}>
              <div className="crm-alert-critical-head">
                <div className="crm-alert-critical-head-copy">
                  <strong>{item.comercio || "Sin comercio"}</strong>
                  <p>{item.tipoAlerta || "Sin tipo de alerta"}</p>
                </div>

                <div className="crm-alert-critical-badges">
                  <PostventaBadge
                    value={item.segmentoComercial ? `Segmento ${item.segmentoComercial}` : "Segmento Nuevo"}
                    tone={toneForSegment(item.segmentoComercial)}
                  />
                  <PostventaBadge
                    value={item.patronFacturacion || "Diario"}
                    tone={toneForPattern(item.patronFacturacion)}
                  />
                  <PostventaBadge
                    value={item.prioridad || "Critica"}
                    tone={toneForPriority(item.prioridad)}
                  />
                </div>
              </div>

              <div className="crm-alert-critical-stack">
                <div className="crm-alert-critical-row">
                  <span className="crm-alert-critical-row-icon">
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                  </span>
                  <p>
                    <strong>Accion sugerida:</strong> {item.accionSugerida || "-"}
                  </p>
                </div>

                <div className="crm-alert-critical-row crm-alert-critical-row-message">
                  <span className="crm-alert-critical-row-icon">
                    <FontAwesomeIcon icon={faCommentDots} />
                  </span>
                  <div className="crm-alert-critical-row-body">
                    <p>
                      <strong>Mensaje sugerido:</strong>{" "}
                      <em>{item.mensajeSugerido && item.mensajeSugerido !== "-" ? item.mensajeSugerido : "Sin mensaje sugerido disponible."}</em>
                    </p>
                    {item.mensajeSugerido && item.mensajeSugerido !== "-" ? (
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        className="crm-alert-critical-copy-button"
                        onClick={() => onCopyMessage(item.mensajeSugerido)}
                      >
                        Copiar mensaje
                      </Button>
                    ) : null}
                  </div>
                </div>

                <div className="crm-alert-critical-row">
                  <span className="crm-alert-critical-row-icon">
                    <FontAwesomeIcon icon={faLayerGroup} />
                  </span>
                  <p>
                    <strong>Contexto:</strong> {item.resumen || item.motivoPrioridad || "Sin resumen disponible."}
                  </p>
                </div>

                <div className="crm-alert-critical-row crm-alert-critical-row-result">
                  <span className="crm-alert-critical-row-icon is-result">
                    <FontAwesomeIcon icon={faCircleCheck} />
                  </span>
                  <p>
                    <strong>Resultado:</strong>{" "}
                    <PostventaBadge value={item.estado || "Pendiente"} tone={toneForGestionState(item.estado)} />
                  </p>
                </div>
              </div>
            </article>
          )) : (
            <Alert variant="secondary" className="mb-0">No hay alertas criticas para la fecha seleccionada.</Alert>
          )}
        </div>
      </div>

      {rows.length > 3 ? (
        <div className="crm-alert-critical-more">
          <Button variant="link" size="sm" className="crm-alert-critical-more-button" onClick={onToggleExpanded}>
            {expanded ? "Ver menos alertas" : "Ver mas alertas"}
            <FontAwesomeIcon className="ms-2" icon={faChevronDown} style={{ transform: expanded ? "rotate(180deg)" : "none" }} />
          </Button>
        </div>
      ) : null}
    </section>
  );
}
